import { Button, Image, Input } from "antd";
import driverIcon from "../../../assets/svg/driver.svg";
import securityCodeIcon from "../../../assets/svg/Security code.svg";
import React from "react";

export const LoginPage = (props) => {
    const { phoneNumber, setPhoneNumber, getCaptchaImage, captchaImg, setCaptcha, captcha, login } = props

    return (
        <div className="form">
            <Input
                className="mb-15"
                prefix={<img src={driverIcon} alt="driverIcon" />}
                allowClear={true}
                placeholder="شماره تماس"
                onChange={(e) => setPhoneNumber(e.target.value)}
                value={phoneNumber}
            />
            <div className="flex-i flex-items-center">
                <Input
                    prefix={<img src={securityCodeIcon} alt="securityCodeIcon" />}
                    allowClear={true}
                    maxLength={4}
                    style={{ flex: "1 1" }}
                    placeholder="کد امنیتی"
                    onChange={(e) => setCaptcha(e.target.value)}
                    value={captcha}
                />
                <Image
                    className="captcha-image"
                    onClick={() => getCaptchaImage()}
                    src={captchaImg}
                    preview={false}
                    alt="captcha"
                    style={{ border: "1px solid #b1b1b1", borderRadius: 5 }}
                />
            </div>
            <Button
                className="button-promotion mt-30 w-100"
                onClick={() => login()}>
                تایید
            </Button>
        </div>
    )
}